import React from "react";
import cx from "classnames";
import styles from "./common.module.scss";
import { Shimmer } from "./states";

export interface StatCardProps {
  icon?: string;
  heading: string;
  value?: React.ReactNode;
  subValue?: React.ReactNode;
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  heading,
  value,
  subValue,
  loading,
  children,
  className,
}) => {
  if (loading) {
    return (
      <div className={cx(styles.statCard, className, { [styles.wide]: !!children })}>
        <div className={styles.statCardContent}>
          <Shimmer className={styles.statShimmerIcon} />
          <div className={styles.statCardHeading}>
            <Shimmer className={styles.statShimmerHeading} />
            <Shimmer className={styles.statShimmerHeadingShort} />
          </div>
          <Shimmer className={styles.statShimmerValue} />
        </div>
        {children && <Shimmer className={styles.statShimmerChart} />}
      </div>
    );
  }

  return (
    <div className={cx(styles.statCard, className, { [styles.wide]: !!children })}>
      <div className={styles.statCardContent}>
        {icon && <img src={icon} alt="" className={styles.statIcon} />}
        <div className={styles.statCardHeading}>
        <p className={styles.statHeading}>{heading}</p>
        </div>
        <p className={styles.statValue}>
          {value}
          {subValue != null && subValue !== "" && (
            <span className={styles.statValueHint}>{subValue}</span>
          )}
        </p>
      </div>
      {children}
    </div>
  );
};

export const StatCardGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.statGrid}>{children}</div>
);
